import ProductGroupingPartialsVideo from "./ProductGroupingPartialsVideo.component";

export default ProductGroupingPartialsVideo;
